export const APPLICANT_TYPES = [
  { value: 'insuredPerson', label: 'claim.personalData.insuredPerson' },
  { value: 'other', label: 'personalClaim.personalData.otherPhysical' },
  { value: 'otherLegal', label: 'personalClaim.personalData.otherLegal' },
];

export const PAYMENT_RECEIVER_TYPES = [
  {
    value: 'insuredPerson',
    label: 'claim.compensation.paymentReceiverType.insuredPerson',
  },
  {
    value: 'applicant',
    label: 'claim.compensation.paymentReceiverType.applicant',
  },
  {
    value: 'other',
    label: 'claim.compensation.paymentReceiverType.other',
  },
  {
    value: 'otherLegal',
    label: 'claim.compensation.paymentReceiverType.otherLegal',
  },
];
